export const GET_ALL_ENTRIES = 'history/GET_ALL_ENTRIES'
export const GET_ENTRY = 'history/GET_ENTRY'

export const SET_ENTRY = 'history/SET_ENTRY'

export const ADD_ENTRIE = 'history/ADD_ENTRIE'
